import { render, staticRenderFns } from "./ServeurInfo.vue?vue&type=template&id=cfca7918"
import script from "./ServeurInfo.vue?vue&type=script&lang=js"
export * from "./ServeurInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports